module.exports = __webpack_public_path__ + "static/media/m_hairstyle_pompadour_front_vector.ac62bc03.svg";